import React from 'react';
import { G, Path } from 'react-native-svg';

import { IconDef } from './types';

export const Trips: IconDef = {
  svg: (
    <G>
      <Path
        strokeWidth={0}
        d="M13 3C12.4477 3 12 3.44772 12 4C12 4.55228 12.4477 5 13 5H14.1869L14.8119 8H9V7C9 6.44772 8.55129 6 7.99901 6H5C4.44772 6 4 6.44772 4 7C4 7.55228 4.44772 8 5 8H7V8.85994L6.09778 12.0177C3.80093 12.2212 2 14.1503 2 16.5C2 18.9853 4.01472 21 6.5 21C8.98528 21 11 18.9853 11 16.5C11 16.4572 10.9994 16.4145 10.9982 16.372L15.4693 11.1557L15.7213 12.3652C14.1206 13.0547 13 14.6465 13 16.5C13 18.9853 15.0147 21 17.5 21C19.9853 21 22 18.9853 22 16.5C22 14.078 20.0866 12.1029 17.6889 12.0039L15.979 3.79605C15.8824 3.33233 15.4737 3 15 3H13ZM16.1449 14.3987L16.521 16.204C16.6337 16.7446 17.1633 17.0916 17.704 16.979C18.2446 16.8663 18.5916 16.3367 18.479 15.796L18.121 14.0777C19.2013 14.3539 20 15.3337 20 16.5C20 17.8807 18.8807 19 17.5 19C16.1193 19 15 17.8807 15 16.5C15 15.6187 15.456 14.8439 16.1449 14.3987ZM10.3091 14.1028C9.79203 13.283 9.01763 12.6417 8.09931 12.2925L8.7543 10H13.8258L10.3091 14.1028ZM7.54609 14.2287C7.92479 14.4034 8.25235 14.6701 8.50018 15H7.32573L7.54609 14.2287ZM5.46789 14.2223L5.03848 15.7253C4.95227 16.027 5.01269 16.3517 5.20165 16.6022C5.39061 16.8527 5.68621 17 6 17H8.94999C8.71836 18.1411 7.70948 19 6.5 19C5.11929 19 4 17.8807 4 16.5C4 15.4873 4.60212 14.6153 5.46789 14.2223Z"
      />
    </G>
  ),
  svgStyles(color) {
    return {
      fill: color,
      strokeWidth: 0,
    };
  },
};
